(() => {
  'use strict';
  if (window.naryssCartOfferInstalled) return;
  window.naryssCartOfferInstalled = true;
  let busy = false;
  const offers = {
    'lamu-leopard-scarf': { name: 'Lamu', unit: 2490, pair: 3990, trio: 5680, second: true },
    'oxford-hat': { name: 'Oxford', unit: 3990, pair: 5990, trio: 7980, second: true },
    'bristol-newsboy-cap': { name: 'Bristol', unit: 3990, pair: 5990, trio: 7980, second: true },
    'the-venise': { name: 'Venise', unit: 3990, pair: 3990, trio: 5580, second: false }
  };
  const canadaRules = {
    'lamu-leopard-scarf': { name: 'Lamu', unit: 4900, pair: 7900, trio: 10800, second: true },
    'oxford-hat': { name: 'Oxford', unit: 5900, pair: 8900, trio: 11900, second: true },
    'bristol-newsboy-cap': { name: 'Bristol', unit: 5900, pair: 8900, trio: 11900, second: true },
    'the-venise': { name: 'Venise', unit: 4900, pair: 4900, trio: 6900, second: false }
  };
  const excludedVariants = new Set([52790029058337]);
  const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  async function request(path, body) {
    const response = await fetch(root + path, {
      method: body ? 'POST' : 'GET', credentials: 'same-origin', cache: 'no-store',
      headers: body ? { 'Content-Type': 'application/json', Accept: 'application/json' } : { Accept: 'application/json' },
      ...(body ? { body: JSON.stringify(body) } : {})
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Please try again.');
    return data;
  }
  function matches(cart, config, quantity, total) {
    return cart.currency === config.currency && cart.item_count === quantity && cart.total_price === total &&
      cart.items.length > 0 && cart.items.every(item =>
        item.product_id === config.product && item.original_price === config.rule.unit && !item.selling_plan_allocation);
  }
  async function add(card) {
    if (!Object.prototype.hasOwnProperty.call(offers, card.dataset.handle)) return;
    if (busy) return;
    const button = card.querySelector('[data-offer-add]');
    const select = card.querySelector('[data-offer-variant]');
    const error = card.querySelector('[data-offer-error]');
    const config = {
      product: Number(card.dataset.product), quantity: Number(card.dataset.quantity),
      total: Number(card.dataset.total), target: Number(card.dataset.target), kind: card.dataset.kind,
      currency: card.dataset.currency || 'USD',
      rule: card.dataset.currency === 'CAD' ? canadaRules[card.dataset.handle] : offers[card.dataset.handle]
    };
    const variant = Number(select.value);
    const temporarilyExcluded = new Set((card.dataset.excludedVariants || "").split(",").filter(Boolean).map(Number));
    if (!config.rule || !Number.isSafeInteger(variant) || variant <= 0 || excludedVariants.has(variant) || temporarilyExcluded.has(variant)) return;
    const marker = 'offer-' + (window.crypto?.randomUUID?.() || Date.now() + '-' + Math.random().toString(36).slice(2));
    const originalLabel = button.textContent;
    let attempted = false, uncertain = false;
    busy = true; button.disabled = true; select.disabled = true;
    card.setAttribute('aria-busy', 'true'); error.hidden = true;
    button.textContent = 'Adding…';
    try {
      const before = config.currency === 'CAD' && window.NaryssLamuCanada ? await window.NaryssLamuCanada.ensure() : await request('cart.js');
      const expectedKind = config.quantity === 1 ? 'second' : 'third';
      const expectedTotal = config.quantity === 1 ? config.rule.unit : config.rule.pair;
      const expectedTarget = config.quantity === 1 ? config.rule.pair : config.rule.trio;
      if ((config.quantity === 1 && !config.rule.second) || ![1, 2].includes(config.quantity) || config.kind !== expectedKind || config.total !== expectedTotal ||
          config.target !== expectedTarget || !matches(before, config, config.quantity, config.total) ||
          before.items.some(item => item.properties?._naryss_cart_offer === 'second' || item.properties?._naryss_lamu_offer === 'second')) {
        throw new Error('Your bag has changed. Please refresh the page before trying again.');
      }
      attempted = true;
      await request('cart/add.js', { items: [{ id: variant, quantity: 1, properties: {
        _naryss_cart_offer: config.kind, _naryss_offer_id: marker
      } }] });
      const after = config.currency === 'CAD' && window.NaryssLamuCanada ? await window.NaryssLamuCanada.ensure() : await request('cart.js');
      const marked = after.items.find(item => item.properties?._naryss_offer_id === marker);
      if (!marked || marked.quantity !== 1 || !matches(after, config, config.quantity + 1, config.target)) {
        throw new Error('The offer discount could not be applied.');
      }
      // Reload the current preview URL, preserving Shopify's theme preview parameters.
      window.location.reload();
      return;
    } catch (failure) {
      let message = failure.message || 'Unable to add the offer. Please try again.';
      if (attempted) {
        try {
          const current = await request('cart.js');
          const marked = current.items.find(item => item.properties?._naryss_offer_id === marker);
          if (marked) {
            await request('cart/change.js', { id: marked.key, quantity: 0 });
            const restored = config.currency === 'CAD' && window.NaryssLamuCanada ? await window.NaryssLamuCanada.ensure() : await request('cart.js');
            if (restored.items.some(item => item.properties?._naryss_offer_id === marker)) throw new Error('Removal not confirmed');
            message = 'The offer discount could not be applied. The extra ' + config.rule.name + ' was removed. Please refresh your bag.';
          }
        } catch (_) {
          uncertain = true;
          message = 'We could not confirm the contents of your bag. Please refresh the page before trying again.';
        }
      }
      error.textContent = message; error.hidden = false;
      // Require a refresh after any attempted mutation to avoid using stale prices or line keys.
      uncertain = uncertain || attempted;
    } finally {
      busy = false; card.removeAttribute('aria-busy');
      button.textContent = originalLabel; button.disabled = uncertain; select.disabled = uncertain;
    }
  }
  document.addEventListener('click', event => {
    if (busy && event.target.closest('cart-items, #main-cart-footer, cart-drawer, [name="checkout"]')) {
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    const button = event.target.closest('[data-offer-add]');
    if (!button) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const card = button.closest('[data-naryss-cart-offer]');
    if (card) void add(card);
  }, true);
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-offer-variant]');
    if (select) {
      // Shrine's cart-items change listener must not treat this color selection as a quantity update.
      event.stopImmediatePropagation();
      const img = select.closest('[data-naryss-cart-offer]').querySelector('[data-offer-image]');
      const option = select.selectedOptions[0];
      if (img && option?.dataset.image) { img.src = option.dataset.image; img.alt = 'The ' + select.closest('[data-naryss-cart-offer]').dataset.name + ' — ' + option.textContent.trim(); }
    } else if (busy && event.target.closest('cart-items, #main-cart-footer, cart-drawer')) {
      event.preventDefault(); event.stopImmediatePropagation();
    }
  }, true);
  document.addEventListener('submit', event => {
    if (busy) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
})();
